import { FormInstance } from 'antd/es/form'
import { TimeBand } from './PreparationTime'

export const validateDynamicPreparationTimeBands = (form: FormInstance) => {
  return {
    validator(_rule: any, value: TimeBand[]) {
      const timeBands = value || []

      if (timeBands.length === 0) return Promise.resolve()

      const isValid = timeBands.every((band: TimeBand, index: number) => {
        const isLastBand = index === timeBands.length - 1
        const isAndAbove = band?.upper_threshold_type === 'and_above'

        const upperThresholdValid =
          isLastBand && isAndAbove ? true : band?.upper_threshold !== null

        return (
          band?.lower_threshold !== undefined &&
          band?.lower_threshold !== null &&
          upperThresholdValid &&
          band?.extra_minutes !== undefined &&
          band?.extra_minutes !== null
        )
      })

      if (!isValid && timeBands.length >= 1) {
        return Promise.reject(
          'All fields in a row must be filled before you can add a new rule'
        )
      }

      return Promise.resolve()
    }
  }
}

export const validateLowerThreshold = (
  form: FormInstance,
  fieldName: number
) => {
  return {
    validator(_rule: any, lowerThreshold: number) {
      const timeBands: TimeBand[] =
        form.getFieldValue('dynamic_preparation_time_bands') ?? []

      const currentBand = timeBands[fieldName]
      if (!currentBand) return Promise.resolve()

      const upperThreshold = currentBand.upper_threshold
      const isNotFirstRow = fieldName > 0
      const previousRowUpperThreshold =
        timeBands[fieldName - 1]?.upper_threshold
      const upperThresholdType = currentBand.upper_threshold_type

      if (
        lowerThreshold >= upperThreshold! &&
        upperThresholdType !== 'and_above' &&
        upperThresholdType !== null
      ) {
        return Promise.reject(
          'Lower basket limit must be less than upper basket limit'
        )
      } else if (isNotFirstRow && lowerThreshold < previousRowUpperThreshold!) {
        return Promise.reject(
          'Lower basket limit must be equal to the previous upper basket limit'
        )
      } else if (isNotFirstRow && lowerThreshold > previousRowUpperThreshold!) {
        return Promise.reject(
          'Lower basket limit must be equal to the previous upper basket limit'
        )
      }
      return Promise.resolve()
    }
  }
}

export const validateUpperThreshold = (
  form: FormInstance,
  fieldName: number
) => {
  return {
    validator(_rule: any, value: number) {
      const timeBands: TimeBand[] =
        form.getFieldValue('dynamic_preparation_time_bands') ?? []

      const currentBand = timeBands[fieldName]
      if (!currentBand) return Promise.resolve()

      const isLastBand = fieldName === timeBands.length - 1

      if (isLastBand && currentBand.upper_threshold_type !== 'and_above') {
        return Promise.reject(
          'The final upper basket limit field must be "And above".'
        )
      }

      if (+value <= +currentBand.lower_threshold!) {
        return Promise.reject(
          'Upper basket limit must be greater than lower basket limit'
        )
      }
      return Promise.resolve()
    }
  }
}

export const validateAdditionalPrepTime = () => {
  return {
    validator(_rule: any, value: number) {
      if (+value === 0 || !value) {
        return Promise.reject('Additional prep time is required')
      }
      return Promise.resolve()
    }
  }
}
